import ClaimantWaiting from "./ClaimantWaiting";

export default ClaimantWaiting;
